import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import QuizList from '../components/quiz/QuizList'

const QuizListPage = () => {
  return (
    <>
    <Navbar/>
    <QuizList/>
    </>
  )
}

export default QuizListPage